
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Shield, CheckCircle, Award, Users, Leaf, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function BelgelendirmeHizmetleri() {
  const { t } = useTranslation();

  const services = [
    {
      icon: Globe,
      title: t('services.belgelendirme.sustainable'),
      description: 'Turizm işletmelerinin çevresel, sosyal ve ekonomik sürdürülebilirlik kriterlerini karşıladığını belgeleyen uluslararası standart.',
      features: [
        'Çevresel etki değerlendirmesi',
        'Sosyal sorumluluk kriterleri',
        'Ekonomik sürdürülebilirlik',
        'Yerel toplum katkısı',
        'Kültürel miras korunması'
      ],
      image: 'https://public.readdy.ai/ai/img_res/ccdb43e161a7f20849894e49495eb2f6.jpg'
    },
    {
      icon: Award,
      title: t('services.belgelendirme.gstc'),
      description: 'Küresel sürdürülebilir turizm konseyi tarafından belirlenen standartlara uygunluk sertifikası.',
      features: [
        'Uluslararası tanınırlık',
        'Sürdürülebilir yönetim',
        'Sosyo-ekonomik etkiler',
        'Kültürel etkiler',
        'Çevresel etkiler'
      ],
      image: 'https://readdy.ai/api/search-image?query=GSTC%20global%20sustainable%20tourism%20council%20certification%20with%20international%20recognition%20symbols%2C%20world%20map%2C%20sustainable%20tourism%20icons%2C%20professional%20certificate%20design%2C%20modern%20clean%20background&width=600&height=400&seq=2&orientation=landscape'
    },
    {
      icon: Users,
      title: t('services.belgelendirme.personnel'),
      description: 'Çeşitli sektörlerde çalışan personelin yetkinlik ve becerilerini belgeleyen sertifikasyon programları.',
      features: [
        'Mesleki yetkinlik değerlendirmesi',
        'Eğitim programları',
        'Sınav ve değerlendirme',
        'Sürekli gelişim takibi',
        'Uluslararası geçerlilik'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20staff%20certification%20with%20diverse%20group%20of%20certified%20professionals%20holding%20certificates%2C%20training%20materials%2C%20competency%20assessment%20tools%2C%20modern%20office%20environment%2C%20clean%20professional%20aesthetic&width=600&height=400&seq=3&orientation=landscape'
    },
    {
      icon: Leaf,
      title: t('services.belgelendirme.vegan'),
      description: 'Ürünlerin vegan standartlarına uygunluğunu belgeleyen sertifikasyon hizmeti.',
      features: [
        'Hayvansal içerik analizi',
        'Üretim süreci denetimi',
        'Tedarik zinciri kontrolü',
        'Etiketleme standartları',
        'Sürekli izleme'
      ],
      image: 'https://readdy.ai/api/search-image?query=Vegan%20product%20certification%20with%20organic%20plant-based%20products%2C%20green%20leaves%2C%20vegan%20certification%20symbols%2C%20natural%20ingredients%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=600&height=400&seq=4&orientation=landscape'
    }
  ];

  const certificationProcess = [
    {
      step: '01',
      title: 'Başvuru ve Ön Değerlendirme',
      description: 'Belgelendirme talebinizin alınması ve ön değerlendirme yapılması'
    },
    {
      step: '02',
      title: 'Dokümantasyon İncelemesi',
      description: 'Gerekli belgelerin incelenmesi ve eksikliklerin belirlenmesi'
    },
    {
      step: '03',
      title: 'Sahada Denetim',
      description: 'Uzman denetçilerimiz tarafından yerinde denetim gerçekleştirilmesi'
    },
    {
      step: '04',
      title: 'Değerlendirme ve Karar',
      description: 'Denetim sonuçlarının değerlendirilmesi ve sertifikasyon kararı'
    },
    {
      step: '05',
      title: 'Sertifika Düzenlenmesi',
      description: 'Uygunluk durumunda sertifikanın düzenlenmesi ve teslimi'
    },
    {
      step: '06',
      title: 'Sürekli İzleme',
      description: 'Sertifika geçerlilik süresince periyodik izleme denetimleri'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section 
          className="relative py-24 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20certification%20services%20with%20modern%20office%20environment%2C%20certification%20documents%2C%20quality%20assurance%20symbols%2C%20professional%20team%20working%2C%20clean%20corporate%20aesthetic%2C%20blue%20and%20white%20color%20scheme&width=1920&height=800&seq=5&orientation=landscape')`
          }}
        >
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center text-white">
              <h1 className="text-5xl font-bold mb-6">{t('services.belgelendirme.title')}</h1>
              <p className="text-xl leading-relaxed">
                {t('services.belgelendirme.description')}
              </p>
            </div>
          </div>
        </section>

        {/* Services Detail */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Belgelendirme Hizmetlerimiz</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Her sektörün özel ihtiyaçlarına yönelik kapsamlı belgelendirme çözümleri
              </p>
            </div>

            <div className="space-y-16">
              {services.map((service, index) => (
                <div key={index} className={`flex flex-col lg:flex-row items-center gap-12 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                  <div className="lg:w-1/2">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-80 object-cover rounded-lg shadow-lg"
                    />
                  </div>
                  <div className="lg:w-1/2">
                    <div className="flex items-center mb-4">
                      <service.icon className="w-8 h-8 text-red-600 mr-3" />
                      <h3 className="text-3xl font-bold text-gray-800">{service.title}</h3>
                    </div>
                    <p className="text-gray-600 mb-6 text-lg leading-relaxed">
                      {service.description}
                    </p>
                    <ul className="space-y-3 mb-6">
                      {service.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-start">
                          <CheckCircle className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <button className="bg-red-600 text-white px-8 py-3 rounded-lg hover:bg-red-700 transition-colors font-medium whitespace-nowrap cursor-pointer">
                      {t('common.learnMore')}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Certification Process */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Belgelendirme Süreci</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Şeffaf ve sistematik süreçlerimizle güvenilir belgelendirme hizmeti
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {certificationProcess.map((step, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                    {step.step}
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Belgelendirmenin Avantajları</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Sertifikalarımızla işletmenizin güvenilirliğini ve rekabet gücünü artırın
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Shield className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Güvenilirlik</h3>
                <p className="text-gray-600">Müşteri güvenini artıran uluslararası sertifikalar</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Rekabet Avantajı</h3>
                <p className="text-gray-600">Pazarda öne çıkmanızı sağlayan kalite belgesi</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Globe className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Uluslararası Tanınırlık</h3>
                <p className="text-gray-600">Global pazarlarda geçerli sertifikasyon</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Sürekli İyileştirme</h3>
                <p className="text-gray-600">Düzenli denetimlerle sürekli gelişim</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-red-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold mb-6">Belgelendirme Sürecinizi Başlatın</h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Uzman ekibimiz size en uygun belgelendirme çözümlerini sunmak için hazır. 
              Hemen başvurun ve işletmenizin güvenilirliğini artırın.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-red-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                Başvuru Yap
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white hover:text-red-600 transition-colors whitespace-nowrap cursor-pointer">
                Bilgi Al
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
